import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

export const useComposeTeamOnboardFlow = () => {
  const {
    flags: { ftueOnboardFlow = 'classic' },
  } = useFeatureFlags();
  return ftueOnboardFlow as
    | 'classic'
    | 'semi_pro'
    | 'f2p'
    | 'compose_first_team';
};
